import { useState, useRef, useEffect } from "react";
import { ChevronDown, ChevronRight, Users } from "lucide-react";
import { useSelector } from "react-redux";
import { ReduxState } from "@/redux/type";
import { setSession } from "@/redux/actions/sessionAction";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

export default function CardCodeDropdown() {
    const customer = useSelector((state: ReduxState) => state.customer);
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setOpen(false);
            }
        }
        if (open) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [open]);


    return (
        <div className="relative w-full" ref={dropdownRef}>
            <button
                className="flex items-center justify-between w-full px-3 py-2 border border-slate-300 rounded 
        bg-white shadow-sm text-sm font-medium text-slate-700 hover:border-amber-400 focus:outline-none 
        focus:ring-2 focus:ring-amber-200 transition-all duration-200 hover:shadow-md"
                aria-haspopup="listbox"
                aria-expanded={open}
            >
                <div className="flex-grow flex items-center min-w-0">
                    <Users className="h-4 w-4 flex-shrink-0 mr-2 text-slate-600 " />
                    <span className="truncate min-w-0">{customer.cardCode ? `${customer.cardCode} (${customer.name})` : "Select Account"}</span>
                </div>

            </button>

        </div>
    );
} 